import { Component, Input, NgModule, OnInit } from '@angular/core';
import {
  NgbActiveModal,
  NgbDate,
  NgbDatepickerNavigateEvent,
  NgbDateStruct,
  NgbModal
} from "@ng-bootstrap/ng-bootstrap";
import { GPlanService } from "../_services/gplan-service/gplan.service";
import { DateUtils } from "../_commons/date-utils";
import { GPlanInput } from '../_models/gplan-input';
import { GuiService } from '../_services/gui-service/gui.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { CableDetails } from '../_models/cable-details';
import { GMonService } from '../_services/gmon-service/gmon.service';
import { LaService } from '../_services/la-service/la.service';
import { InputService } from '../_services/input/input.service';
import { CableProperty } from '../_models/cable-property';
import { MapService } from '../_services/map/map.service';
import { GridElementDetails } from '../_models/grid-element-details';
import { StartEndsList } from '../_models/start-end-list';
import { StartEnd } from '../_models/start-end';
import { PlanningNode } from '../_models/planning-node';
import { PlanningCable } from '../_models/planning-cable';
import { ConfigurationService } from '../_services/configuration/configuration.service';
import { TranslateService } from '@ngx-translate/core';
import { SwitchingStateInTimePeriod, PlanningState, PlanningSwitchingState } from '../_models/cable-switching-state';
import { FormGroup, FormControl, Validators, } from '@angular/forms';
import { GridElement } from '../_models/grid-element';
import { Cable } from '../_models/cable';
import { MapViewDialogComponent } from './map-view-dialog/map-view-dialog.component';
import { ModalService } from '../_services/modal/modal.service';
import { BasicAlertComponent } from '../_commons/basic-alert/basic-alert.component';
import { BasicConfirmationComponent } from '../_commons/basic-confirmation/basic-confirmation.component';
import { GridElementRoot } from '../_models/grid-element-root';
import { P } from '@angular/cdk/keycodes';
import { PlanningTrafoDtos } from '../_models/planning-trafo-dtos';
import { PlanningTrafoDtosFrontend } from '../_models/planning-trafo-dtos-frontend';
import { single } from 'rxjs-compat/operator/single';
import { NgbPopoverModule } from '@ng-bootstrap/ng-bootstrap';
type AnyObject = { [key: string]: any };
@Component({
  selector: 'app-gplan-dialog',
  templateUrl: './gplan-dialog.component.html',
  styleUrls: ['./gplan-dialog.component.css']
})
export class GplanDialogComponent implements OnInit {
  @Input()
  editPlanningScenarioMode: boolean;
  public scenarioToEdit: GPlanInput;
  private topology: any;
  gplanNodes: boolean = false;
  gplanLines: boolean = false;
  gplanSwitches: boolean = false;
  gplanTrafos: boolean = false;
  addSubTrees: boolean = false;
  cableProperties: Array<any>;
  fromDate: NgbDateStruct;
  toDate: NgbDateStruct;
  isCableToSelected = false;
  toggleValue: boolean = false;
  toggleRefPV: boolean = false;
  toggleRefPVValue: string = "";

  selectedByPeriod: Record<number, number> = {};

  availableScenariosPlanning: Array<GPlanInput> = new Array<GPlanInput>();

  // ogmEnabled: boolean = false;
  //node: string;
  //measurementsOffsetToActiveEnergyOrPower: number;
  //unitActive: string;
  //measurementsOffsetToReactiveEnergyOrPower: number;
  //unitReactive: string;
  //cableFrom: string;
  //cableTo: string;
  //cableTyp: string;
  //cableLength: any;
  //cableResistance: any;
  //cableReactance: any;
  //cableCapacitance: any;

  nodeNameList: Array<string> =  new Array<string>();
  trafoNameList: Array<string> = new Array<string>();
  nodeNameMap: Map<string, AnyObject> = new Map<string, any>();
  trafoNameMap: Map<string, AnyObject> = new Map<string, any>();
  cableFromNameList: Array<string> = new Array<string>();
  cableToNameList: Array<string> = [];
  cablePropertiesMap: Map<string, CableProperty> = new Map<string, CableProperty>();
  cableDetailsList: Array<CableDetails> = new Array<CableDetails>();
  cableTypeNameList: Array<string> = new Array<string>();
  startEndsList: StartEndsList = new StartEndsList();
  numberOfDay: number;
  isNodeLocale: boolean = false;
  isInvalidCableLength = false;
  isInvalidAdditionalPower: boolean = false;
  isInvalidTrafoRatio: boolean = false;
  isInvalidPowerFactor: boolean = false;
  isInvalidTrafoSize: boolean = false;
  isInvalidPowerFactorExistingGenerator: boolean = false;

  isInvalidDate: boolean = false;
  isCableInvalid: boolean = false;
  private dataIsBeingLoaded: string;
  planning: string;
  planning_name = "";
  additionalLoadGenerationOn: boolean = true;
  nodeAdditionalLoadGenerationOn: boolean = false;
  modifyLineOn: boolean = false;
  changeSwitchingStateOn: boolean = false;
  addSubTreeOn: boolean = false;
  switchingStateInTimePeriodList: Array<SwitchingStateInTimePeriod> = [];
  switchingStateToNeighbourList: Array<SwitchingStateInTimePeriod> = [];
  planningSwitchingStateList: PlanningSwitchingState[][];
  public formNewNodeTab!: FormGroup;
  public formAdditionalLoadGeneration!: FormGroup;
  public formModifyLine!: FormGroup;
  public planningNodeList: Array<PlanningNode> = [];
  public planningCableList: Array<PlanningCable> = [];
  public planningTrafoDtos: Array<PlanningTrafoDtos> = [];
  public planningTrafoFrontend: Array<PlanningTrafoDtosFrontend> = [];
  public planningTrafoFrontendSingle: Array<any> = new Array<any>();
  public planningList: Array<PlanningState> = []
  public planningListWithoutMixed: Array<PlanningState> = []
  public originalCableTyp: string;
  public originalCableLength: number;
  public translations: any;
  public open: any;
  public closed: any;
  public mixed: any;
  public missingInputDataError: boolean = false;
  public samePlanningNameOnEditMode: boolean = false;

  public listOfElementsNameTest: Array<string> = new Array<string>();

  public planningNameNotSelected: boolean = false;
  public changeNotPerformed: boolean = false;
  public nodesMap: Map<number, GridElement> = new Map<number, GridElement>();
  public confirmationPopupTitle: any;
  public messageSamePlanningName: any;

  public worstCaseEnabled: boolean = false;
  public formWorstCase!: FormGroup;

  public trafoNameAlreadyInTable: boolean = false;

  public defaultDeratingFactorValue: number;

  public modifyLineTabEnabled: boolean = false;
  public switchWithinCurrentTopologyTabEnabled: boolean = false;
  public switchToAdjacentTopologyTabEnabled: boolean = false;

  constructor(
    public ngbModal: NgbModal,
    public activeModal: NgbActiveModal,
    private mapService: MapService,
    private gPlanService: GPlanService,
    private guiService: GuiService,
    private gMonService: GMonService,
    private laService: LaService,
    private inputService: InputService,
    private dateUtils: DateUtils,
    private spinner: NgxSpinnerService,
    private translateService: TranslateService,
    private configurationService: ConfigurationService,
    private gplanService: GPlanService
  ) {
    this.dataIsBeingLoaded = this.translateService.instant("Data-is-being-loaded");
    //this.topology = this.configurationService.getConfiguration().TOPOLOGY;
    this.gplanNodes = this.configurationService.getConfiguration().APPLICATIONS.gplanNodes;
    this.gplanLines = this.configurationService.getConfiguration().APPLICATIONS.gplanLines;
    this.gplanSwitches = this.configurationService.getConfiguration().APPLICATIONS.gplanSwitches;
    this.gplanTrafos = this.configurationService.getConfiguration().APPLICATIONS.gplanTrafos;
    this.addSubTrees = this.configurationService.getConfiguration().APPLICATIONS.addSubTree;

    // Translations
    const language = localStorage.getItem("Language");
    translateService.getTranslation(language).subscribe((translations) => {
      console.log("Translations: ", translations);
      this.translations = translations;
      this.open = translations["code-string"]['open'];
      this.closed = translations["code-string"]['closed'];
      this.mixed = translations["code-string"]['mixed'];
      this.confirmationPopupTitle = translations["code-string"]['confirmation-popup-title'];
      this.messageSamePlanningName = translations["code-string"]['same-message-planning-name'];
      this.planningList = [
        {
          "id": 1,
          "state": this.open,
          "state_en": "OPEN"
        },
        {
          "id": 2,
          "state": this.closed,
          "state_en": "CLOSED"
        },
        {
          "id": 3,
          "state": this.mixed,
          "state_en": "MIXED"
        }
      ];

      this.planningListWithoutMixed = [
        {
          "id": 1,
          "state": this.open,
          "state_en": "OPEN"
        },
        {
          "id": 2,
          "state": this.closed,
          "state_en": "CLOSED"
        }
      ];
    });
  }

  ngOnInit() {
    console.log("On init call... ");
    console.log(this.scenarioToEdit);

    this.formNewNodeTab = new FormGroup({
      nodeNodeTab: new FormControl("", Validators.required),
      measurementsTrafoRatio: new FormControl("", Validators.required),
      measurementsTrafoSize: new FormControl("", Validators.required)
    })

    this.defaultValuesLoadFormNodeTab();

    this.formAdditionalLoadGeneration = new FormGroup({
      node: new FormControl("", Validators.required),
      measurementsOffsetToReactiveEnergyOrPower: new FormControl("", Validators.required),
      measurementsOffsetToActiveEnergyOrPower: new FormControl("", Validators.required),
      unitActive: new FormControl("", Validators.required),
      unitReactive: new FormControl("", Validators.required),
    })

    this.defaultValuesLoadForm();

    this.formModifyLine = new FormGroup({
      cableFrom: new FormControl("", Validators.required),
      cableTo: new FormControl("", Validators.required),
      cableTyp: new FormControl("", Validators.required),
      cableLength: new FormControl("", Validators.required),
      cableResistance: new FormControl(""),
      cableReactance: new FormControl(""),
      cableCapacitance: new FormControl(""),
    });

    this.formModifyLine.patchValue({
      cableFrom: undefined,
      cableTo: undefined,
      cableTyp: undefined,
      cableLength: "",
      cableResistance: "",
      cableReactance: "",
      cableCapacitance: "",
    })

    this.formWorstCase = new FormGroup({
      voltageAtRoot: new FormControl("", Validators.required),
      powerFactorExistingGenerator: new FormControl("", Validators.required),
      powerFactor: new FormControl("", Validators.required),
      deratingFactor: new FormControl("", Validators.required)
    });

    if (localStorage.getItem("planningNodeList")) {
      this.planningNodeList = JSON.parse(localStorage.getItem("planningNodeList"));
    }

    if (localStorage.getItem("planningCableList")) {
      this.planningCableList = JSON.parse(localStorage.getItem("planningCableList"));
    }

    this.topology = JSON.parse(localStorage.getItem("currentTopology"));

    this.initValue();
    this.getNodeNameList();
    // this.getTrafoNameList();
    this.getNodesFrom();
    this.getAllCableProperties();

    this.inputService.getDefaultDate("fromDateDefault");
    this.fromDate = this.inputService.getDefaultDate("fromDateDefault");
    this.toDate = this.inputService.getDefaultDate("toDateDefault");
    if (this.fromDate && this.toDate) {
    console.log("@@BURAX")
      this.getPlanningState();
      this.getSwitchingStateToNeighbour();
    }

    if (this.editPlanningScenarioMode) {
      this.scenarioToEdit = JSON.parse(localStorage.getItem("currentScenarioEdit"))
      this.fillPlanningTab();
      this.fillTrafoTabTable();
    }

    if (this.scenarioToEdit && this.scenarioToEdit.type == "WC") {
      this.toggleValue = true
      this.worstCaseEnabled = true;
      this.defaultDeratingFactorValue = 1;
      //if value is negative -> cos fi capacitive
      if (this.scenarioToEdit.powerFactorExistingGenerator < 0) {
        this.formWorstCase.patchValue({
          voltageAtRoot: this.scenarioToEdit.voltageAtRoot,
          powerFactorExistingGenerator: Math.abs(this.scenarioToEdit.powerFactorExistingGenerator),
          powerFactor: "capacitive",
          deratingFactor: this.scenarioToEdit.deratingFactorExistingGenerator
        });
      }
      //if value is 0 or positive -> cos fi inductive
      else {
        this.formWorstCase.patchValue({
          voltageAtRoot: this.scenarioToEdit.voltageAtRoot,
          powerFactorExistingGenerator: Math.abs(this.scenarioToEdit.powerFactorExistingGenerator),
          powerFactor: "inductive",
          deratingFactor: this.scenarioToEdit.deratingFactorExistingGenerator
        });
      }
    }

    this.gplanService.isTrafoTabChecked = false;
  }

  getSwitchingStateTranslation(state: string) {
    if (state == 'MIXED') {
      return this.mixed
    }
    if (state == 'OPEN') {
      return this.open
    }
    if (state == 'CLOSED') {
      return this.closed
    }
  }

  defaultValuesLoadForm() {
    this.formAdditionalLoadGeneration.patchValue({
      node: undefined,
      measurementsOffsetToActiveEnergyOrPower: 0,
      measurementsOffsetToReactiveEnergyOrPower: 1,
      unitActive: "production",
      unitReactive: "inductive"
    })
  };

  defaultValuesLoadFormNodeTab(){
    this.formNewNodeTab.patchValue({
      nodeNodeTab: undefined,
      measurementsTrafoRatio: 0,
      measurementsTrafoSize: 1
    })
  }

  onSelectDate() {
    if (this.fromDate && this.toDate) {
      this.getPlanningState();
      this.getSwitchingStateToNeighbour()
    }
    if(this.editPlanningScenarioMode)
      this.fillPlanningTab();
  }

  onSelectChangePlanning(planningStateId: number, cableSwitchingState: SwitchingStateInTimePeriod) {
    console.log("onSelectChangePlanning called with id: ", planningStateId, "cable swithcing state: ", cableSwitchingState);
    let newPlanningState = "";
    if (planningStateId) {
      if (this.planningList) {
        console.log("Here is the planning list before: ", this.planningList);
        this.planningList.forEach(element => {
          if (element.id == planningStateId) {
            newPlanningState = element.state_en;
            cableSwitchingState.planning = newPlanningState;
          }
        });
      }
    }
  }

  onSelectSubTree(planningStateId: number, switchingStateToNeighbour: SwitchingStateInTimePeriod) {
    let newPlanningState = "";
    if (planningStateId) {
      if (this.planningList) {
        this.planningList.forEach(element => {
          if (element.id == planningStateId) {
            newPlanningState = element.state_en;
            switchingStateToNeighbour.planning = newPlanningState;
          }
        });
      }
    }
  }

  /*
  // get State In English Language
  getState(state: string) {
    let englishState: string;
    this.planningList.forEach(element => {
      if (element.state == state) {
        if (element.id == 1) {
          englishState = "OPEN"
        };
        if (element.id == 2) {
          englishState = "CLOSED"
        }
        if (element.id == 3) {
          englishState = "MIXED"
        }
      }
    });
    return englishState
  }*/



  getPlanningState() {
  console.log("@@@@BURA")
    let fromDate: any;
    let toDate: any;
    if (this.fromDate.year && this.fromDate.month && this.fromDate.day
      && this.toDate && this.toDate.month && this.toDate.day) {

      fromDate = this.dateUtils.dateStringToString1(this.fromDate.year, this.fromDate.month, this.fromDate.day);
      toDate = this.dateUtils.dateStringToString1(this.toDate.year, this.toDate.month, this.toDate.day);

      this.switchingStateInTimePeriodList = [];

      if(localStorage.getItem("switchingStateInTimePeriods")){
        this.switchingStateInTimePeriodList = JSON.parse(localStorage.getItem("switchingStateInTimePeriods"));
      }else{
        this.mapService.getSwitchingStateInTimePeriod(this.topology.topologyId, fromDate, toDate).subscribe(
          (cableSwitchingStateList: Array<SwitchingStateInTimePeriod>) => {
            if (cableSwitchingStateList) {
              this.switchingStateInTimePeriodList = cableSwitchingStateList;
            }
          }
        );
      }
    }
  }

  getPlanningStateLastTopologyChange() {
  console.log("@@@@BURA WC")

  let date = DateUtils.stringLocalDateToUTC(this.topology.lastTopologyChange);
  this.switchingStateInTimePeriodList = [];
  this.mapService.getSwitchingStateInTimePeriod(this.topology.topologyId, date, date).subscribe(
    (cableSwitchingStateList: Array<SwitchingStateInTimePeriod>) => {
      if (cableSwitchingStateList) {
        this.switchingStateInTimePeriodList = cableSwitchingStateList;
      }
    });
  }

  getSwitchingStateToNeighbour() {
    let fromDate: any;
    let toDate: any;
    if (this.fromDate.year && this.fromDate.month && this.fromDate.day
      && this.toDate && this.toDate.month && this.toDate.day) {

      fromDate = this.dateUtils.dateStringToString1(this.fromDate.year, this.fromDate.month, this.fromDate.day);
      toDate = this.dateUtils.dateStringToString1(this.toDate.year, this.toDate.month, this.toDate.day);

      this.switchingStateToNeighbourList = [];
      this.mapService.getSwitchingStateToNeighbourInTimePeriod(this.topology.topologyId, fromDate, toDate).subscribe(
        (switchingStateToNeighbour: Array<SwitchingStateInTimePeriod>) => {
          if (switchingStateToNeighbour) {
            this.switchingStateToNeighbourList = switchingStateToNeighbour;
          }

        });
    }
  }

    getSwitchingStateToNeighbourLastTopologyChange() {

      let date = DateUtils.stringLocalDateToUTC(this.topology.lastTopologyChange);
      this.switchingStateToNeighbourList = [];
      this.mapService.getSwitchingStateToNeighbourInTimePeriod(this.topology.topologyId, date, date).subscribe(
        (switchingStateToNeighbour: Array<SwitchingStateInTimePeriod>) => {
          if (switchingStateToNeighbour) {
            this.switchingStateToNeighbourList = switchingStateToNeighbour;
          }

        });
    }


  private getCableTypeName(id: number) {
    let cableTypesJson: string = localStorage.getItem('cableTypes');
    let cableTypes: Array<any> = JSON.parse(cableTypesJson);

    let cableTypeName: string = "";
    if (cableTypes) {
      cableTypes.forEach(element => {
        if (element.id == id) {
          cableTypeName = element.Name
        }
      });
    }
    return cableTypeName;
  }

  private getNodeName(id: number) {
    let nodeName: string = "";
    let gridElementsJson: string = localStorage.getItem('gridElements');
    let gridElements: Array<GridElement> = JSON.parse(gridElementsJson);

    this.nodesMap = JSON.parse(localStorage.getItem('nodeMap'));
    if (gridElements != null) {
      this.nodesMap.forEach((value: GridElement, key: number) => {
        if (value.gridElementId == id) {
          if (value.properties) {
            value.properties.forEach(property => {
              if (property.name == "name") {
                nodeName = property.value
              }
            });
          }
        }
      });

    }
    return nodeName;
  }


  addPlanningNodeNodeTab(){
    console.log("values of the form ... ", this.formNewNodeTab)
    let nodeNodeTab = this.formNewNodeTab.get("nodeNodeTab").value;
    let measurementsTrafoRatio = this.formNewNodeTab.get("measurementsTrafoRatio").value;
    let measurementsTrafoSize = this.formNewNodeTab.get("measurementsTrafoSize").value;
    // this.formNewNodeTab.get("nodeNodeTab").
    if(nodeNodeTab){
      // const planningTrafo: PlanningTrafoDtos = new PlanningTrafoDtos();

      const planningTrafoFrontend: PlanningTrafoDtosFrontend = new PlanningTrafoDtosFrontend();
      // planningTrafo.gridElementId = nodeNodeTab;
      // console.log("The value that I'm looking for ... " ,this.nodeNameMap.get(nodeNodeTab))
      if(this.isLvTopologyIsChoosen()){
        planningTrafoFrontend.existingMVorSSBGridElementId = this.trafoNameMap.get(nodeNodeTab).gridElementId;
        planningTrafoFrontend.gridElementName = this.trafoNameMap.get(nodeNodeTab).internalDsoId;
      }else{
        planningTrafoFrontend.existingMVorSSBGridElementId = this.nodeNameMap.get(nodeNodeTab).gridElementId;
        if(planningTrafoFrontend.existingMVorSSBGridElementId === undefined){
           planningTrafoFrontend.existingMVorSSBGridElementId = this.nodeNameMap.get(nodeNodeTab).gridelementId;
        }
        planningTrafoFrontend.gridElementName =  this.nodeNameMap.get(nodeNodeTab).name;
        if(planningTrafoFrontend.gridElementName === undefined){
          planningTrafoFrontend.gridElementName = this.nodeNameMap.get(nodeNodeTab).internalDsoId;
        }
      }
      // planningTrafo.existingMVorSSBGridElementId = nodeNodeTab;
      console.log("Planning tab : ", planningTrafoFrontend.existingMVorSSBGridElementId)
      if(measurementsTrafoRatio > 0){
        // console.log("Measurement checker ... ", measurementsTrafoRatio)

        planningTrafoFrontend.trafoRatio = measurementsTrafoRatio;
      }else{
        this.isInvalidTrafoRatio = true;
        return;
      }
      if(measurementsTrafoSize > 0){

        planningTrafoFrontend.trafoSize_kVA = measurementsTrafoSize;
      }else{
        this.isInvalidTrafoSize = true;
        return;
      }

      if(!this.planningTrafoFrontend){
        this.planningTrafoFrontend = [];
      }

      this.trafoNameAlreadyInTable = this.planningTrafoFrontend.some(someTrafo => someTrafo.gridElementName === planningTrafoFrontend.gridElementName)

      if(this.trafoNameAlreadyInTable){
        console.log("You choosed the trafo that already present on the table ", this.trafoNameAlreadyInTable)
      }else{
        this.planningTrafoFrontend.push(planningTrafoFrontend);
        localStorage.setItem("planningTrafoList", JSON.stringify(this.planningTrafoFrontend));
        this.defaultValuesLoadFormNodeTab();

      }

      console.log("Here is the planning Trafo frontend" , this.planningTrafoFrontend)
      // this.planningTrafoFrontend.push(planningTrafoFrontend);
      // localStorage.setItem("planningTrafoList", JSON.stringify(this.planningTrafoFrontend));
      // this.defaultValuesLoadFormNodeTab();
    }
  }



  addPlanningNode() {
    //chech those values
    //get values by input forms
    let node = this.formAdditionalLoadGeneration.get("node").value
    let measurementsOffsetToActiveEnergyOrPower = this.formAdditionalLoadGeneration.get("measurementsOffsetToActiveEnergyOrPower").value
    let measurementsOffsetToReactiveEnergyOrPower = this.formAdditionalLoadGeneration.get("measurementsOffsetToReactiveEnergyOrPower").value
    let unitActive = this.formAdditionalLoadGeneration.get("unitActive").value
    let unitReactive = this.formAdditionalLoadGeneration.get("unitReactive").value

    if (node) {
      const planningNode: PlanningNode = new PlanningNode();
      planningNode.gridelementId = node;
      planningNode.nodeGridelementId = this.nodeNameMap.get(node).gridelementId;
      if (measurementsOffsetToActiveEnergyOrPower >= 0) {
        if (unitActive == "production") {
          measurementsOffsetToActiveEnergyOrPower = -Math.abs(measurementsOffsetToActiveEnergyOrPower)
          //planningNode.offsetActivePowerKWType = "production";
        } else {
          //planningNode.offsetActivePowerKWType = "consumption";
        }
        planningNode.offsetActivePowerKW = measurementsOffsetToActiveEnergyOrPower;
      } else {
        this.isInvalidAdditionalPower = true;
        return;
      }
      if (measurementsOffsetToReactiveEnergyOrPower > 0 &&
        measurementsOffsetToReactiveEnergyOrPower <= 1) {

        if (unitReactive == "capacitive") {
          measurementsOffsetToReactiveEnergyOrPower = -Math.abs(measurementsOffsetToReactiveEnergyOrPower)
          //planningNode.offsetReactivePowerCosPhiType = "capacitive"
        } else {
          //planningNode.offsetReactivePowerCosPhiType = "inductive"
        }

        planningNode.offsetReactivePowerCosPhi = measurementsOffsetToReactiveEnergyOrPower;
      } else {
        this.isInvalidPowerFactor = true;
        return;
      }

      if (!this.planningNodeList) {
        this.planningNodeList = [];
      }
      this.planningNodeList.push(planningNode);
      localStorage.setItem("planningNodeList", JSON.stringify(this.planningNodeList))
      //default form values
      this.defaultValuesLoadForm();
    }
  }

  addPlanningCable() {
    let cableLength = this.formModifyLine.get("cableLength").value
    let cableFrom = this.formModifyLine.get("cableFrom").value
    let cableTo = this.formModifyLine.get("cableTo").value
    let cableTyp = this.formModifyLine.get("cableTyp").value

    if (this.isCableValide()) {
      if (cableLength < 0) {
        this.isInvalidCableLength = true;
        return;
      }
      const planningCable: PlanningCable = new PlanningCable();

      planningCable.cableGridelementId = this.getCableDetails(cableFrom, cableTo).gridElementId;
      planningCable.lengthKm = cableLength;
      planningCable.cabletypeId = this.cablePropertiesMap.get(cableTyp).id;
      planningCable.cabletype = cableTyp;
      planningCable.startNode = cableFrom;
      planningCable.endNode = cableTo;
      if (!this.planningCableList) {
        this.planningCableList = [];
      }
      this.planningCableList.push(planningCable);
    } else {
      if (this.isCableInvalid) {
        return;
      }
    }

    localStorage.setItem("planningCableList", JSON.stringify(this.planningCableList))
    //default form values
    this.defaultValuesLineForm();

  }

  defaultValuesLineForm() {
    this.formModifyLine.patchValue({
      cableFrom: "",
      cableTo: "",
      cableTyp: "",
      cableLength: "",
      cableResistance: "",
      cableReactance: "",
      cableCapacitance: "",
    })
  };

  removePlanninNode(item: PlanningNode) {
    console.log(item);
    if (this.planningNodeList) {
      if (this.planningNodeList) {
        this.planningNodeList.forEach((element, index) => {
          if ((element.nodeGridelementId == item.nodeGridelementId) && (element.offsetActivePowerKW == item.offsetActivePowerKW) && (element.offsetReactivePowerCosPhi == item.offsetReactivePowerCosPhi)) {
            this.planningNodeList.splice(index, 1);
            console.log(this.planningNodeList)
          }
        });
      }
      localStorage.setItem("planningNodeList", JSON.stringify(this.planningNodeList));
    }
  }

  removeTrafoNode(item: PlanningTrafoDtosFrontend){
    console.log(item);
    if(this.planningTrafoFrontend){
      if(this.planningTrafoFrontend){
        this.planningTrafoFrontend.forEach((element, index) => {
          if((element.existingMVorSSBGridElementId == item.existingMVorSSBGridElementId) && (element.trafoRatio == item.trafoRatio) && (element.trafoSize_kVA && item.trafoSize_kVA)){
            this.planningTrafoFrontend.splice(index, 1);
            console.log(this.planningTrafoFrontend)
          }
        })
      }
    }
  }

  removePlanninCable(item: PlanningCable) {
    console.log(item);
    if (this.planningCableList) {
      if (this.planningCableList) {
        this.planningCableList.forEach((element, index) => {
          if ((element.cableGridelementId == item.cableGridelementId) && (element.lengthKm == item.lengthKm) && (element.cabletypeId == item.cabletypeId)) {
            this.planningCableList.splice(index, 1);
            console.log(this.planningCableList)
          }
        });
      }
      localStorage.setItem("planningCableList", JSON.stringify(this.planningCableList));
    }
  }

  newNodeTabChecked(){

    this.nodeAdditionalLoadGenerationOn = true;
    this.additionalLoadGenerationOn = false;
    this.modifyLineOn = false;
    this.changeSwitchingStateOn = false;
    this.addSubTreeOn = false;
    // console.log(" The state of the node Additoinal Load Genearion changed ", this.nodeAdditionalLoadGenerationOn)
    this.gplanService.isTrafoTabChecked = true;
    this.getNodeNameList();
  }

  additionalLoadGeneration() {
    this.nodeAdditionalLoadGenerationOn = false;
    this.additionalLoadGenerationOn = true;
    this.modifyLineOn = false;
    this.changeSwitchingStateOn = false;
    this.addSubTreeOn = false;
    this.gplanService.isTrafoTabChecked = false;
    this.getNodeNameList();
  }

  modifyLine() {
    this.nodeAdditionalLoadGenerationOn = false;
    this.additionalLoadGenerationOn = false;
    this.modifyLineOn = true;
    this.changeSwitchingStateOn = false;
    this.addSubTreeOn = false;
    this.cableToNameList = [""];
  }

  changeSwitchingState() {
    this.nodeAdditionalLoadGenerationOn = false;
    this.additionalLoadGenerationOn = false;
    this.modifyLineOn = false;
    this.changeSwitchingStateOn = true;
    this.addSubTreeOn = false;

    if(localStorage.getItem("switchingStateInTimePeriods")){
      this.switchingStateInTimePeriodList = JSON.parse(localStorage.getItem("switchingStateInTimePeriods"));
    }

  }

  addSubTree() {
    this.nodeAdditionalLoadGenerationOn = false;
    this.addSubTreeOn = true;
    this.additionalLoadGenerationOn = false;
    this.modifyLineOn = false;
    this.changeSwitchingStateOn = false;
  }

  onChangeFromNode($event) {
    console.log("called onChangeFromNode...")
    this.initValue();
    let cableFrom = this.formModifyLine.get("cableFrom").value
    this.cableToNameList = this.getPosibleNodesTo(cableFrom);
  }

  onChangeToNode($event) {
    console.log("called onChangeToNode...")
    let cableFrom = this.formModifyLine.get("cableFrom").value
    let cableTo = this.formModifyLine.get("cableTo").value

    if (this.getPosibleNodesTo(cableFrom).indexOf(cableTo) == -1) {
      this.isCableInvalid = true;
    } else {
      this.isCableInvalid = false;
    }
    let cableDetails: CableDetails;
    if (cableFrom && cableTo) {
      cableDetails = this.getCableDetails(cableFrom, cableTo);
      if (cableDetails == null) {
        cableDetails = this.getCableDetails(cableTo, cableFrom);
        if (cableDetails == null) {
          return;
        }
      }

      let cableTyp = cableDetails.type

      if (this.cableTypeNameList.indexOf(cableTyp) === -1) {
        console.error(cableTyp + " is unknown in cable-details");
        // this.cableTypeNameList.push(this.cableTyp);
      }

      const cableProperty = this.cablePropertiesMap.get(cableTyp);

      //store original values for cableTyp and cableDetails.length useful to verfy when user change it -> isFormDirty()
      this.originalCableTyp = cableTyp;
      this.originalCableLength = cableDetails.length;

      if (cableProperty) {
        this.formModifyLine.patchValue({
          cableTyp: cableTyp,
          cableLength: cableDetails.length,
          cableResistance: cableProperty.resistance,
          cableReactance: cableProperty.reactance,
          cableCapacitance: cableProperty.capacitance
        })
      }
      this.isCableToSelected = false;
    }
  }

  //verify if the user changed the form
  isFormDirty() {
    let currentCableTyp = this.formModifyLine.get("cableTyp").value
    let currentCableLength = this.formModifyLine.get("cableLength").value
    if (currentCableTyp != this.originalCableTyp || currentCableLength != this.originalCableLength) {
      return true
    }
    else {
      return false
    }
  }

  onChangeCableLength($event) {
    console.log("called onChangeCableLength...")
    let cableLength = this.formModifyLine.get("cableLength").value
    if (cableLength < 0) {
      this.isInvalidCableLength = true;
    } else {
      this.isInvalidCableLength = false;
    }
  }

  onChangeAdditionalPower($event) {
    console.log("called onChangeAdditionalPower...")
    let measurementsOffsetToActiveEnergyOrPower = this.formAdditionalLoadGeneration.get("measurementsOffsetToActiveEnergyOrPower").value
    if (measurementsOffsetToActiveEnergyOrPower >= 0) {
      this.isInvalidAdditionalPower = false;
    } else {
      this.isInvalidAdditionalPower = true;
      return;
    }
  }

  onChangeAdditionalPowerNodeTab($event){
    console.log("called onChangeAdditionalPowerNodeTab...");
    let measurementsTrafoSize = this.formNewNodeTab.get("measurementsTrafoRatio").value
    if(measurementsTrafoSize >= 0 ){
      this.isInvalidTrafoRatio = false;
    }else{
      this.isInvalidTrafoRatio = true;
      return;
    }
  }

  onChangePowerFactor($event) {
    console.log("called onChangePowerFactor...")
    console.log("called onChangePowerFactorNodeTab...")
    let measurementsOffsetToReactiveEnergyOrPower = this.formAdditionalLoadGeneration.get("measurementsOffsetToReactiveEnergyOrPower").value
    if (measurementsOffsetToReactiveEnergyOrPower > 0 &&
      measurementsOffsetToReactiveEnergyOrPower <= 1) {
      this.isInvalidPowerFactor = false;
    } else {
      this.isInvalidPowerFactor = true;
    }
  }

  onChangePowerFactorNodeTab($event){
    console.log("called onChangePowerFactorNodeTab...")
    // console.log("is hte form valid? ... ", this.formNewNodeTab)
    // console.log("in it true ? ...", this.checkMeasurementsTrafoSize())
    // console.log("is the form is valid Proverka ..>", !this.formNewNodeTab.valid)
    // console.log("blya res of metoda: >>> ", this.checkMeasurementsTrafoSize());
    let measurementsTrafoRatio = this.formNewNodeTab.get("measurementsTrafoSize").value
    if(measurementsTrafoRatio > 0){
      this.isInvalidTrafoSize = false;
    }else{
      this.isInvalidTrafoSize = true;
    }
  }

  onChangePowerFactorWorstCase($event) {
    console.log("called onChangePowerFactor...")
    let powerFactorExistingGenerator = this.formWorstCase.get("powerFactorExistingGenerator").value
    if (powerFactorExistingGenerator > 0 &&
      powerFactorExistingGenerator <= 1) {
      this.isInvalidPowerFactorExistingGenerator = false;
    } else {
      this.isInvalidPowerFactorExistingGenerator = true;
    }
  }

  onChangeCableTyp($event) {
    console.log("called onChangeCableTyp...")
    let cableTyp = this.formModifyLine.get("cableTyp").value;
    if (this.cableTypeNameList.indexOf(cableTyp) === -1) {
      this.initValue();
      return;
    }
    const cableProperty = this.cablePropertiesMap.get(cableTyp);
    if (cableProperty) {
      this.formModifyLine.patchValue({
        cableResistance: cableProperty.resistance,
        cableReactance: cableProperty.reactance,
        cableCapacitance: cableProperty.capacitance
      })
    }
  }

  initValue() {
    console.log("called initValue...")
    // this.cableTo = "";
    this.isCableToSelected = true;
    // this.cableTyp = "";

    this.formModifyLine.patchValue({
      cableLength: "",
      cableResistance: "",
      cableReactance: "",
      cableCapacitance: ""
    })

  }

  getUnsignedNumber(number: number) {
    let unsignedNumber = Math.abs(number);
    return unsignedNumber;
  }

  saveGPlan(){

    let planSwitchStateList: Array<PlanningSwitchingState> = [];

    if(this.editPlanningScenarioMode == false){
      if(this.switchingStateInTimePeriodList){
        this.switchingStateInTimePeriodList.forEach(element => {
          if(element.planning && element.planning != '' && element.planning != element.switchingState){
            let planningSwitchingState: PlanningSwitchingState = new PlanningSwitchingState(
              element.cableGridElementID,
              element.planning,
              element.fromNode_dsoInternalID,
              element.toNode_dsoInternalID
            );
            planSwitchStateList.push(planningSwitchingState)
          }
        })
      }
    }

    let planSwitchNeighbourList: Array<PlanningSwitchingState> = [];

    if(this.switchingStateToNeighbourList){
      this.switchingStateToNeighbourList.forEach(element => {
        if(element.planning && element.planning != '' && element.planning != element.switchingState){
          const planningSwitchingStateToNeighbour: PlanningSwitchingState = new PlanningSwitchingState(
            element.cableGridElementID,
            element.planning,
            element.fromNode_dsoInternalID,
            element.toNode_dsoInternalID
          );
          planSwitchNeighbourList.push(planningSwitchingStateToNeighbour);
        }
      });
    }
    const gplanInput: GPlanInput = this.getGplanInput(planSwitchStateList, planSwitchNeighbourList, this.planningTrafoDtos);
    console.log("Saving scenario: ", gplanInput);

    const existing: Array<GPlanInput> = JSON.parse(localStorage.getItem('scenarios') || '[]')

    const scenariosArray = Array.isArray(existing) ? existing : [existing];
    scenariosArray.push(gplanInput);

    localStorage.setItem('scenariosFromGPlan', JSON.stringify(scenariosArray));
  }

  runGPlan() {
    console.log("run gplanning call... ");
    console.log(this.fromDate);
    console.log(this.toDate);

    let fromDate;
    let toDate;

    //check if the date is valid
    if (this.fromDate && this.toDate &&
      this.fromDate.year && this.fromDate.month && this.fromDate.day &&
      this.toDate.year && this.toDate.month && this.toDate.day) {
      //date is valid
      this.isInvalidDate = false;
    }
    else {
      //date is invalid
      this.isInvalidDate = true;
    }

    //check if the planning name has been entered
    if (this.planning_name != "") {
      this.planningNameNotSelected = false
    }
    else {
      this.planningNameNotSelected = true
    }

    let planSwitchStateList: Array<PlanningSwitchingState> = [];
    let planSwitchNeighbourList: Array<PlanningSwitchingState> = [];

    //No edit mode
    if (this.editPlanningScenarioMode == false) {
      //planSwitchStateList
      if (this.switchingStateInTimePeriodList) {
        this.switchingStateInTimePeriodList.forEach(element => {
          console.log("Element planning BEFORE state: ", element.planning);
          //consider only element with the different state than current state
          if (element.planning && element.planning != '' && element.planning != element.switchingState) {
            let planningSwitchingState: PlanningSwitchingState = new PlanningSwitchingState(
              element.cableGridElementID,
              element.planning,
              element.fromNode_dsoInternalID,
              element.toNode_dsoInternalID);
            planSwitchStateList.push(planningSwitchingState)

          }
          console.log("Element planning AFTER state: ", element.planning);
        });
      }

      //planSwitchNeighbourList
      if (this.switchingStateToNeighbourList) {
        this.switchingStateToNeighbourList.forEach(e => {
          //consider only element with the different state than current state
          if (e.planning && e.planning != '' && e.planning != e.switchingState) {
            const planningSwitchingStateToNeighbour: PlanningSwitchingState = new PlanningSwitchingState(
              e.cableGridElementID,
              e.planning,
              e.fromNode_dsoInternalID,
              e.toNode_dsoInternalID);
            planSwitchNeighbourList.push(planningSwitchingStateToNeighbour)
          }
        });
      }
    }

    //Edit mode
    if (this.editPlanningScenarioMode == true) {
      //add planSwitchStateList to gplanInput
      if (this.switchingStateInTimePeriodList) {
        this.switchingStateInTimePeriodList.forEach(element => {
          //consider only element  where "oringinal state"!="planning state"
          if (element.original && element.original != '' && element.planning && element.planning != '' && element.original != element.planning) {
            let planningSwitchingState: PlanningSwitchingState = new PlanningSwitchingState(
              element.cableGridElementID,
              element.planning,
              element.fromNode_dsoInternalID,
              element.toNode_dsoInternalID);
            planSwitchStateList.push(planningSwitchingState)
          }
        });
      }

      //add planSwitchNeighbourList to gplanInput
      if (this.switchingStateToNeighbourList) {
        this.switchingStateToNeighbourList.forEach(element => {
          //consider only element  where "oringinal state"!="planning state"
          if (element.original && element.original != '' && element.planning && element.planning != '' && element.original != element.planning) {
            const planningSwitchingStateToNeighbour: PlanningSwitchingState = new PlanningSwitchingState(
              element.cableGridElementID,
              element.planning,
              element.fromNode_dsoInternalID,
              element.toNode_dsoInternalID);
            planSwitchNeighbourList.push(planningSwitchingStateToNeighbour)
          }
        });
      }
    }

    // check if any changes have been made in the grid
    if (
      planSwitchStateList.length > 0 || planSwitchNeighbourList.length > 0 ||
      (this.planningNodeList == null || this.planningNodeList.length > 0) ||
      this.planningCableList.length > 0 ||
      (this.planningTrafoFrontend == null || this.planningTrafoFrontend.length > 0)) {
        this.changeNotPerformed = false;
    }
    else {
      this.changeNotPerformed = true;
    }

    //NORMAL MODE
    //run gplan only if date is valid, planning name is selected and at least one change on the grid  has been made
    this.planningTrafoDtos = this.planningTrafoFrontend.map(({ existingMVorSSBGridElementId, trafoRatio, trafoSize_kVA}) => ({
      existingMVorSSBGridElementId,
      trafoRatio,
      trafoSize_kVA
    }));

    if (this.editPlanningScenarioMode == false) {
      if (!this.isInvalidDate && !this.planningNameNotSelected && !this.changeNotPerformed) {
        const gplanInput: GPlanInput = this.getGplanInput(planSwitchStateList, planSwitchNeighbourList, this.planningTrafoDtos);
        // console.log("THIs is my GPLAn input ... " , gplanInput)
        // console.log("Output from the getGplanInput... ", this.getGplanInput(planSwitchStateList, planSwitchNeighbourList, this.planningTrafoDtos));

        this.guiService.runGPlan(gplanInput).subscribe((response) => {
          if(response.body == null){
            this.gplanService.isGPlanFinishedWithError();
          }
        });
        this.activeModal.dismiss('gplanStarted');
        //localStorage.setItem("currentScenario", JSON.stringify(gplanInput));
      }

      //if date is not valid, planning name is not selected and not at least one change on the grid has been made show en error on GUI
      else {
        this.missingInputDataError = true;
      }
    }

    //EDIT MODE
    //run gplan only if date is valid, planning name is selected and is different from the previus name
    if (this.editPlanningScenarioMode == true) {
      let isTheSameName = false;

      //check if date and name are valid
      if (!this.isInvalidDate && !this.planningNameNotSelected) {
        //check if the name if different
        const gplanInput: GPlanInput = this.getGplanInput(planSwitchStateList, planSwitchNeighbourList, this.planningTrafoDtos);
        // console.log("THIs is my GPLAn input ... " , gplanInput)
        // console.log("Output from the getGplanInput... ", this.getGplanInput(planSwitchStateList, planSwitchNeighbourList, this.planningTrafoDtos));

        if (!isTheSameName) {
          this.guiService.runGPlan(gplanInput).subscribe((response) => {
            if(response.body == null){
              this.gplanService.isGPlanFinishedWithError();
            }
          });
          this.activeModal.dismiss('gplanStarted');
          //localStorage.setItem("currentScenario", JSON.stringify(gplanInput));
        }
        else {
          this.samePlanningNameOnEditMode = true;
          gplanInput.id = this.scenarioToEdit.id;
          let modalRef = this.ngbModal.open(BasicConfirmationComponent,
            {
              size: 'lg',
              ariaLabelledBy: 'modal-basic-title',
              centered: false,
              scrollable: true,
              backdrop: 'static'
            });

          (<BasicConfirmationComponent>modalRef.componentInstance).title = this.confirmationPopupTitle;
          (<BasicConfirmationComponent>modalRef.componentInstance).content = this.messageSamePlanningName;

          modalRef.result.then(
            (result) => {
              console.log("result: " + result);
              if (result == 'confirm') {
                this.guiService.runGPlan(gplanInput).subscribe((response) => {
                  if(response.body == null){
                    this.gplanService.isGPlanFinishedWithError();
                  }
                 });
                this.activeModal.dismiss('gplanStarted');
                //localStorage.setItem("currentScenario", JSON.stringify(gplanInput));
              }
            }
          );
        }
      }

      else {
        this.missingInputDataError = true;
      }
    }
  }

  /**
   * Run Gplan for worst case
   */
  runGPlanWorstCase() {
    console.log("run gplanning call for worst case... ");

    // get volatgeAtRoot and powerFactorExistingGenerator from input form
    let volatgeAtRoot = this.formWorstCase.get("voltageAtRoot").value
    let powerFactorExistingGenerator = this.formWorstCase.get("powerFactorExistingGenerator").value
    let powerFactor = this.formWorstCase.get("powerFactor").value
    let deratingFactor = this.formWorstCase.get("deratingFactor").value;
    if (powerFactorExistingGenerator > 0 &&
      powerFactorExistingGenerator <= 1) {

      if (powerFactor == "capacitive") {
        powerFactorExistingGenerator = -Math.abs(powerFactorExistingGenerator)
        //planningNode.offsetReactivePowerCosPhiType = "capacitive"
      } else {
        //planningNode.offsetReactivePowerCosPhiType = "inductive"
      }
    }

    //check if the planning name has been entered
    if (this.planning_name != "") {
      this.planningNameNotSelected = false
    }
    else {
      this.planningNameNotSelected = true
    }

    let planSwitchStateList: Array<PlanningSwitchingState> = [];
    let planSwitchNeighbourList: Array<PlanningSwitchingState> = [];

    if (this.editPlanningScenarioMode == false) {
      //planSwitchStateList
      if (this.switchingStateInTimePeriodList) {
        // console.log("Switching state in time period list ", this.switchingStateInTimePeriodList)
        this.switchingStateInTimePeriodList.forEach(element => {
          //consider only element with the different state than current state
          if (element.planning && element.planning != '' && element.planning != element.switchingState) {
            let planningSwitchingState: PlanningSwitchingState = new PlanningSwitchingState(
              element.cableGridElementID,
              element.planning,
              element.fromNode_dsoInternalID,
              element.toNode_dsoInternalID);
            planSwitchStateList.push(planningSwitchingState)
          }
        });
      }

      //planSwitchNeighbourList
      if (this.switchingStateToNeighbourList) {
        this.switchingStateToNeighbourList.forEach(e => {
          //consider only element with the different state than current state
          if (e.planning && e.planning != '' && e.planning != e.switchingState) {
            const planningSwitchingStateToNeighbour: PlanningSwitchingState = new PlanningSwitchingState(
              e.cableGridElementID,
              e.planning,
              e.fromNode_dsoInternalID,
              e.toNode_dsoInternalID);
            planSwitchNeighbourList.push(planningSwitchingStateToNeighbour)
          }
        });
      }
    }


    //Edit mode
    if (this.editPlanningScenarioMode == true) {
      //add planSwitchStateList to gplanInput
      if (this.switchingStateInTimePeriodList) {
        this.switchingStateInTimePeriodList.forEach(element => {
          //consider only element  where "oringinal state"!="planning state"
          if (element.original && element.original != '' && element.planning && element.planning != '' && element.original != element.planning) {
            let planningSwitchingState: PlanningSwitchingState = new PlanningSwitchingState(
              element.cableGridElementID,
              element.planning,
              element.fromNode_dsoInternalID,
              element.toNode_dsoInternalID);
            planSwitchStateList.push(planningSwitchingState)
          }
        });
      }

      //add planSwitchNeighbourList to gplanInput
      if (this.switchingStateToNeighbourList) {
        this.switchingStateToNeighbourList.forEach(element => {
          //consider only element  where "oringinal state"!="planning state"
          if (element.original && element.original != '' && element.planning && element.planning != '' && element.original != element.planning) {
            const planningSwitchingStateToNeighbour: PlanningSwitchingState = new PlanningSwitchingState(
              element.cableGridElementID,
              element.planning,
              element.fromNode_dsoInternalID,
              element.toNode_dsoInternalID);
            planSwitchNeighbourList.push(planningSwitchingStateToNeighbour)
          }
        });
      }
    }

    // check if any changes have been made in the grid
    if (planSwitchStateList.length > 0 || planSwitchNeighbourList.length > 0 || (this.planningNodeList == null || this.planningNodeList.length > 0) || this.planningCableList.length > 0 || (this.planningTrafoFrontend == null || this.planningTrafoFrontend.length > 0)) {
      this.changeNotPerformed = false;
    }
    else {
      this.changeNotPerformed = true;
    }

    //NORMAL MODE
    //run gplan only if date is valid, planning name is selected and at least one change on the grid  has been made
    if (this.editPlanningScenarioMode == false) {
      // console.log("run gplan worst case in normal mode");
      // console.log("here is the check: " + this.planning_name + " " + this.changeNotPerformed  + " + some data : "  + this.planningNodeList + " planning nodes length " + this.planningNodeList.length + "  pllanning cable list : " + this.planningCableList);
      if (!this.planningNameNotSelected && !this.changeNotPerformed) {

        const gplanInput: GPlanInput = this.getGplanInputWorstCase(planSwitchStateList, planSwitchNeighbourList, volatgeAtRoot, powerFactorExistingGenerator, deratingFactor);
        this.guiService.runGPlan(gplanInput).subscribe((response) => {
          if(response.body == null){
            this.gplanService.isGPlanFinishedWithError();
          }
         });
        this.activeModal.dismiss('gplanStarted');
        //localStorage.setItem("currentScenario", JSON.stringify(gplanInput));
      }

      //if date is not valid, planning name is not selected and not at least one change on the grid has been made show en error on GUI
      //18.08.2025. The problem is that we don't have date in worst case planning we need to remove this check (I need to ask Domagoj about it)
      else {
        this.missingInputDataError = true;
      }
    }

    //EDIT MODE
    //run gplan only if date is valid, planning name is selected and is different from the previus name
    if (this.editPlanningScenarioMode == true) {
      let isTheSameName = false;
      if (this.scenarioToEdit.name == this.planning_name) {
        isTheSameName = true
      }

      //check if date and name are valid
      if (!this.planningNameNotSelected) {
        //check if the name if different
        const gplanInput: GPlanInput = this.getGplanInputWorstCase(planSwitchStateList, planSwitchNeighbourList, volatgeAtRoot, powerFactorExistingGenerator, deratingFactor);
        if (!isTheSameName) {
          this.guiService.runGPlan(gplanInput).subscribe((response) => {
            if(response.body == null){
              this.gplanService.isGPlanFinishedWithError();
            }
           });
          this.activeModal.dismiss('gplanStarted');
          //localStorage.setItem("currentScenario", JSON.stringify(gplanInput));
        }
        else {
          this.samePlanningNameOnEditMode = true;
          gplanInput.id = this.scenarioToEdit.id;

          let modalRef = this.ngbModal.open(BasicConfirmationComponent,
            {
              size: 'lg',
              ariaLabelledBy: 'modal-basic-title',
              centered: false,
              scrollable: true,
              backdrop: 'static'
            });

          (<BasicConfirmationComponent>modalRef.componentInstance).title = this.confirmationPopupTitle;
          (<BasicConfirmationComponent>modalRef.componentInstance).content = this.messageSamePlanningName;

          modalRef.result.then(
            (result) => {
              console.log("result: " + result);
              if (result == 'confirm') {
                this.guiService.runGPlan(gplanInput).subscribe((response) => {
                  if(response.body == null){
                    this.gplanService.isGPlanFinishedWithError();
                  }
                 });
                this.activeModal.dismiss('gplanStarted');
                //localStorage.setItem("currentScenario", JSON.stringify(gplanInput));
              }
            }
          );
        }
      }

      else {
        this.missingInputDataError = true;
      }
    }
  }

  /**
   * Get GplanInput
   *
   * @param planSwitchStateList
   * @param planSwitchNeighbourList
   * @returns
   */
  getGplanInput(planSwitchStateList: PlanningSwitchingState[], planSwitchNeighbourList: PlanningSwitchingState[], planningTrafoDtosArray: Array<PlanningTrafoDtos>) {
    let fromDate = this.dateUtils.dateStringToString1(this.fromDate.year, this.fromDate.month, this.fromDate.day);
    let toDate = this.dateUtils.dateStringToString1(this.toDate.year, this.toDate.month, this.toDate.day);
    this.inputService.saveDefaultDate("fromDateDefault", this.fromDate);
    this.inputService.saveDefaultDate("toDateDefault", this.toDate);
    this.numberOfDay = this.inputService.getNumberOfDays(fromDate, toDate);
    this.inputService.saveNumberOfDays('numberOfDayGplan', this.numberOfDay);
    this.inputService.saveNumberOfDays('numberOfDayGmon', this.numberOfDay);
    this.inputService.saveNumberOfDays('numberOfDayLA', this.numberOfDay);

    const gplanInput: GPlanInput = new GPlanInput();
    gplanInput.intervalStart = DateUtils.stringLocalDateToUTC(fromDate);
    gplanInput.intervalEnd = DateUtils.stringLocalDateToUTC(toDate);
    gplanInput.topologyId = this.topology.topologyId;

    gplanInput.planningNodes = this.planningNodeList;
    localStorage.removeItem('planningNodeList');
    gplanInput.planningCables = this.planningCableList;
    localStorage.removeItem('planningCableList');
    gplanInput.planningTrafoDtos = this.planningTrafoDtos;
    localStorage.removeItem('planningTrafoList');

    if(this.toggleRefPV){
      gplanInput.useTimeseriesData = this.toggleRefPVValue
    }else{
      gplanInput.useTimeseriesData = null;
    }

    if (planSwitchStateList.length > 0) {
      //add planning switching states to gplanInput
      gplanInput.planningSwichtingStates = planSwitchStateList;
    }
    if (planSwitchNeighbourList.length > 0) {
      //add subtree to gplanInput
      gplanInput.planningSubgridsDtos = planSwitchNeighbourList;
    }
    if(planningTrafoDtosArray.length > 0) {
      gplanInput.planningTrafoDtos = planningTrafoDtosArray;
    }

    gplanInput.name = this.planning_name;

    console.log("gplanInput", gplanInput);
    this.gMonService.setGMonRunning(false);
    this.laService.setLARunning(false);
    return gplanInput;
  }

  /**
   * Get GplanIntut for worst case
   *
   * @param planSwitchStateList
   * @param planSwitchNeighbourList
   * @param voltageAtRoot
   * @param powerFactorExistingGenerator
   * @returns
   */
  getGplanInputWorstCase(planSwitchStateList: PlanningSwitchingState[], planSwitchNeighbourList: PlanningSwitchingState[], voltageAtRoot: number, powerFactorExistingGenerator: number, deratingFactor: number) {
    const gplanInput: GPlanInput = new GPlanInput();
    gplanInput.topologyId = this.topology.topologyId;
    gplanInput.voltageAtRoot = voltageAtRoot;
    gplanInput.deratingFactorExistingGenerator = deratingFactor;
    gplanInput.powerFactorExistingGenerator = powerFactorExistingGenerator;
    gplanInput.planningNodes = this.planningNodeList;
    localStorage.removeItem('planningNodeList');
    gplanInput.planningCables = this.planningCableList;
    localStorage.removeItem('planningCableList');
    gplanInput.planningTrafoDtos = this.planningTrafoDtos;
    localStorage.removeItem('planningTrafoList')
    gplanInput.planningSwichtingStates = planSwitchStateList;
    gplanInput.planningSubgridsDtos = planSwitchNeighbourList;
    gplanInput.name = this.planning_name;
    gplanInput.type = "WC";
    console.log("gplanInput", gplanInput);
    this.gMonService.setGMonRunning(false);
    this.laService.setLARunning(false);
    return gplanInput;
  }

  isGPlanRunning(): boolean {
    return this.gPlanService.isGPlanRunning();
  }

  /* getDataTokens(i: number) {
     if (i === this.nodeNameList.length - 1) {
       i = 0;
     }
     return this.nodeNameList[++i].toString();
   }*/


  isLvTopologyIsChoosen():boolean {
    const typeOfScenario = localStorage.getItem("gridType");
    const typeOfScenarioStringify: string = JSON.parse(typeOfScenario);
    if(typeOfScenarioStringify == "LV"){
      return true;
    }else{
      return false;
    }
  }

  //IMPROVE THE CODE OF THIS METHOD
  getNodeNameList() {
    console.log("Node Name List call... ");
    this.nodeNameList = [this.dataIsBeingLoaded];
    if(this.additionalLoadGenerationOn){
      const gplanNodeJson = localStorage.getItem("gplanNodes");
      const gridElementDetailsLoc: Array<GridElementDetails> = JSON.parse(gplanNodeJson);
      // console.log("THe parsed elements fo the grid .. " , gridElementDetailsLoc);
      if (gplanNodeJson && gridElementDetailsLoc.length > 0) {
        this.nodeNameList = [];
        this.isNodeLocale = true;
        // console.log("Node Name List Locale ");
        gridElementDetailsLoc.forEach((ged: GridElementDetails) => {
          this.nodeNameList.push(ged.name);
          this.nodeNameMap.set(ged.name, ged);
        });
        this.nodeNameList.sort(function (a, b) {
          return a.localeCompare(b);
        });
      } else {
        this.mapService.getGPlanNodeDetails(this.topology.topologyId).subscribe(
          (gridElementDetails: Array<GridElementDetails>) => {
            localStorage.setItem("gplanNodes", JSON.stringify(gridElementDetails));
            this.nodeNameList = [];
            gridElementDetails.forEach((ged: GridElementDetails) => {
              this.nodeNameList.push(ged.name);
              this.nodeNameMap.set(ged.name, ged);
            });
            this.nodeNameList.sort(function (a, b) {
              return a.localeCompare(b);
            });
            this.isNodeLocale = true;
          },
          (e) => {
            console.error(e);
          });
      }
      console.log("MY selected node list. ", this.nodeNameList,  " THE NUMBER TAB >>>> ", this.additionalLoadGenerationOn)
    }
    if(!this.additionalLoadGenerationOn){
      this.nodeNameList = [];
      if(this.isLvTopologyIsChoosen()){
        // console.log("The type of the scenario is ", typeOfScenarioStringify);
        const getRootNodeFromLVTopology = localStorage.getItem("root");
        const rootNodeFromLVTopology = JSON.parse(getRootNodeFromLVTopology);
        // console.log("The name of the root node of the topology " , rootNodeFromLVTopology.internalDsoId)
        this.trafoNameList.push(rootNodeFromLVTopology.internalDsoId);
        this.trafoNameMap.set(rootNodeFromLVTopology.internalDsoId, rootNodeFromLVTopology)
        // rootNodeFromLVTopology.forEach((ged:GridElementRoot) => {
          // this.trafoNameList.push(rootNodeFromLVTopology.internalDsoId);
        // })
        console.log("|this is the trafo map .... " , this.trafoNameList)
      }
      if(!this.isLvTopologyIsChoosen()){
        const gplanNodeJson = localStorage.getItem("gplanNodes");
        const gridElementDetailsLoc: Array<GridElementDetails> = JSON.parse(gplanNodeJson);
        // console.log("THe parsed elements fo the grid .. " , gridElementDetailsLoc);
        if (gridElementDetailsLoc.length > 0) {
          this.nodeNameList = [];
          this.isNodeLocale = true;
          // console.log("Node Name List Locale ");
          gridElementDetailsLoc.forEach((ged: GridElementDetails) => {
            this.nodeNameList.push(ged.name);
            this.nodeNameMap.set(ged.name, ged);
          });
          this.nodeNameList.sort(function (a, b) {
            return a.localeCompare(b);
          });

          console.log(this.nodeNameMap)
        } else {
          this.mapService.getGPlanNodeDetails(this.topology.topologyId).subscribe(
            (gridElementDetails: Array<GridElementDetails>) => {
              localStorage.setItem("gplanNodes", JSON.stringify(gridElementDetails));
              this.nodeNameList = [];
              gridElementDetails.forEach((ged: GridElementDetails) => {
                this.nodeNameList.push(ged.name);
                this.nodeNameMap.set(ged.name, ged);
              });
              this.nodeNameList.sort(function (a, b) {
                return a.localeCompare(b);
              });
              this.isNodeLocale = true;
            },
            (e) => {
              console.error(e);
            });
          }
        let getRootNodeFromMVTopology = localStorage.getItem("root");
        let rootNodeFromMVTopology = JSON.parse(getRootNodeFromMVTopology);
        this.nodeNameList.push(rootNodeFromMVTopology.internalDsoId);
        this.nodeNameMap.set(rootNodeFromMVTopology.internalDsoId, rootNodeFromMVTopology);
        console.log(this.nodeNameMap);
      }
    }
  }

  getNodesFrom() {
    console.log("Node From List call... ");
    this.mapService.getAllCableDetails(this.topology.topologyId).subscribe((cableDetailsResults: Array<CableDetails>) => {
      // console.log("cableDetail-oninit: " + JSON.stringify(cableDetailsResults));
      if (cableDetailsResults) {
        cableDetailsResults.forEach((cableDetailsResult: CableDetails) => {
          console.log("id-oninit: " + JSON.stringify(cableDetailsResult.sourceGridElementName + " -- " + cableDetailsResult.endGridElementName));
          const cableDetails: CableDetails = new CableDetails(
            cableDetailsResult.gridElementId,
            cableDetailsResult.sourceGridElementName,
            cableDetailsResult.endGridElementName,
            cableDetailsResult.length,
            cableDetailsResult.type,
            cableDetailsResult.resistance,
            cableDetailsResult.reactance,
            cableDetailsResult.capacitanceC1uFKm,
            cableDetailsResult.isOverhead,
            cableDetailsResult.isUnderground,
            cableDetailsResult.maxCurrent
          );
          this.cableDetailsList.push(cableDetails);
        });
      }
      // console.log("cableDetailslenghtAfter " + this.cableDetailsList.length);
      this.cableFromNameList = [];
      let i = 0;


      for (const cableDetails of this.cableDetailsList) {
        const start = cableDetails.sourceGridElementName;
        const end = cableDetails.endGridElementName;
        if (start && end) {

          //if start is not present i add it on the list
          if (this.cableFromNameList.indexOf(start) <= -1) {
            this.startEndsList.startEnds.push(new StartEnd(start, end));
            this.cableFromNameList[i] = start;
            i++;
            //if start is  present i add its end on end list
          } else if (this.cableFromNameList.indexOf(start) > -1) {
            const se: StartEnd = this.startEndsList.getStartEnd(start);
            se.ends.push(end);
          }


          // add bidirectionality for cables

          //if end is not already present into the start node list, add it (as start node) with the related start node (as end node)
          if (this.cableFromNameList.indexOf(end) <= -1) {
            this.startEndsList.startEnds.push(new StartEnd(end, start));
            this.cableFromNameList[i] = end;
            i++;
            // if end is already present into the start node list, i add its start node (as end node)
          } else if (this.cableFromNameList.indexOf(end) > -1) {
            const se: StartEnd = this.startEndsList.getStartEnd(end);
            se.ends.push(start);
          }


          /*
          --> with the following example cables -->

          {
            "gridElementId": 238,
              "sourceGridElementName": "Node 1",
                "endGridElementName": "Node 2"
          },
          {
            "gridElementId": 239,
              "sourceGridElementName": "Node 1",
                "endGridElementName": "Node 3"
          },
          {
            "gridElementId": 240,
              "sourceGridElementName": "Node 4",
                "endGridElementName": "Node 1"
          }

          --> the result "this.startEndsList" will be as the following-->

          { "start": "Node 1"
            "ends": ["Node 2", "Node 3", "Node 4",]
          },
          { "start": "Node 2"
          "ends": ["Node 1"]
          },
          { "start": "Node 3"
          "ends": ["Node 1"]
          },
          { "start": "Node 4"
          "ends": ["Node 1"]
          },

          */
        }
      }
    });
  }


  getPosibleNodesTo(cableFrom: string) {
    console.log("Node To List call... ");
    console.log(this.startEndsList)
    for (const startEnds of this.startEndsList.startEnds) {
      if (startEnds.start == cableFrom) {
        return startEnds.ends;
      }
    }
  }

  getAllCableProperties() {
    console.log("Cable Properties List call... ");
    this.mapService.getCableTypes().subscribe((cableProperties: Array<any>) => {
      if (cableProperties) {
        cableProperties.forEach((value) => {
          const cableProperty = new CableProperty();
          cableProperty.id = value.id;
          cableProperty.name = value.Name;
          cableProperty.resistance = value.R1_Ohmkm;
          cableProperty.capacity = value.currentCarryingCapacity_A;
          cableProperty.reactance = value.X1_Ohmkm;
          cableProperty.capacitance = value.C1_uFkm;
          cableProperty.R0_Ohmkm = value.R0_Ohmkm;
          cableProperty.X0_Ohmkm = value.X0_Ohmkm;
          cableProperty.C0_uFkm = value.C0_uFkm;
          this.cablePropertiesMap.set(value.Name, cableProperty);
          this.cableTypeNameList.push(value.Name);
        });
      }
      // console.log('cableProperties:  ' + this.cablePropertiesMap);
    },
      (e) => console.error(e)
    );
    // this.cableTypeNameList = Array.from(this.cablePropertiesMap.keys());
    // console.log(this.cableTypeNameList);
  }

  getCableDetails(start: string, end: string) {
    console.log("Cable details call... start: " + start + " -- end: " + end);
    if (this.isCableValide()) {
      for (const cd of this.cableDetailsList) {
        if (cd.sourceGridElementName === start || cd.sourceGridElementName === end)
          console.log(cd);
        if ((cd.sourceGridElementName === start && cd.endGridElementName === end) || (cd.sourceGridElementName === end && cd.endGridElementName === start)) {
          return cd;
        }
      }
    }
    return null;
  }

  private isCableValide() {

    let cableFrom = this.formModifyLine.get("cableFrom").value
    let cableTo = this.formModifyLine.get("cableTo").value

    if (this.cableFromNameList.indexOf(cableFrom) != -1) {
      if (this.getPosibleNodesTo(cableFrom).indexOf(cableTo) != -1) {
        return cableFrom && cableTo;
      }
      this.isCableInvalid = true;
      // alert("Choice a Cable correctly/ Leitung richtig wählen");
      return false;
    }
    return false;
  }

  resetInvalidDate() {
    this.isInvalidDate = false;
  }

  resetMissingInputDataError() {
    this.missingInputDataError = false;
  }

  resetPlanningNameNotSelected() {
    this.planningNameNotSelected = false;
  }

  //if “Additional power at node” is != 0 active the "Add Load/Generation" button
  checkMeasurementsOffsetToActiveEnergyOrPower(): boolean {
    let measurementsOffsetToActiveEnergyOrPower = this.formAdditionalLoadGeneration.get("measurementsOffsetToActiveEnergyOrPower").value
    if (measurementsOffsetToActiveEnergyOrPower == 0) {
      return true;
    }
    else {
      return false;
    }
  }

  checkMeasurementsTrafoSize(): boolean{
    let measurementsTrafoSize = this.formNewNodeTab.get("measurementsTrafoSize").value;
    let measurementsTrafoRatio = this.formNewNodeTab.get("measurementsTrafoRatio").value;
    if (measurementsTrafoSize == 0 || measurementsTrafoRatio == 0){
      return true;
    }else{
      return false;
    }
  }

  fillTrafoTabTable(){
    this.gplanService.getListAvailableScenarios().subscribe((listOfScenarios: Array<GPlanInput>) => {
      console.log("Here is the list of scenarios ", listOfScenarios)
      listOfScenarios.forEach((scenario) => {
        if(scenario.planningTrafoDtos.length > 0 && this.scenarioToEdit.id == scenario.id){
          console.log("Scenario htat contains only trafoDTO .... ", scenario)
          scenario.planningTrafoDtos.forEach(planningTrafo =>{

          let planningTrafoFrontendTable: PlanningTrafoDtosFrontend = new PlanningTrafoDtosFrontend();
            // this.planningTrafoFrontendSingle.gridElementName = "";
            this.listOfElementsNameTest.push(this.getNodeName(planningTrafo.existingMVorSSBGridElementId))
            // this.planningTrafoFrontendTable.gridElementName = " ";
            planningTrafoFrontendTable.gridElementName = (this.getNodeName(planningTrafo.existingMVorSSBGridElementId));
            planningTrafoFrontendTable.existingMVorSSBGridElementId = (planningTrafo.existingMVorSSBGridElementId);
            if(planningTrafo.trafoRatio){
              planningTrafoFrontendTable.trafoRatio = (planningTrafo.trafoRatio);
            }else{
              planningTrafoFrontendTable.trafoRatio = null;
            }
            if(planningTrafo.trafoSize_kVA){
              planningTrafoFrontendTable.trafoSize_kVA = (planningTrafo.trafoSize_kVA);
            }else{
              planningTrafoFrontendTable.trafoSize_kVA = null;
            }

            this.planningTrafoFrontend.push(planningTrafoFrontendTable);
          })
        }
      })
    })
  }


  //SHOULD THE BUG RELATED TO THE FILLING INPUTS  ?
  fillPlanningTab() {
    if (this.scenarioToEdit) {
      if(this.planning_name == null || this.planning_name == ""){
        this.planning_name = this.scenarioToEdit.name
      }
      if (this.scenarioToEdit.planningNodes) {
        this.scenarioToEdit.planningNodes.forEach(element => {
          element.gridelementId = this.getNodeName(element.nodeGridelementId)
        });
      }
      if (this.scenarioToEdit.planningCables) {
        this.scenarioToEdit.planningCables.forEach(element => {
          element.cabletype = this.getCableTypeName(element.cabletypeId)
          element.startNode = this.getCableSourceNode(element.cableGridelementId)
          element.endNode = this.getCableEndNode(element.cableGridelementId)
        });
      }

      this.planningNodeList = this.scenarioToEdit.planningNodes
      this.planningCableList = this.scenarioToEdit.planningCables
      const now = new Date();

      if (this.fromDate != null && this.toDate != null) {

        this.scenarioToEdit.intervalStart = this.dateUtils.dateStringToString1(this.fromDate.year, this.fromDate.month, this.fromDate.day);
        this.scenarioToEdit.intervalEnd = this.dateUtils.dateStringToString1(this.toDate.year, this.toDate.month, this.toDate.day);
      }
      console.log("this.scenarioToEdit.intervalStart" + this.scenarioToEdit.intervalStart)
      console.log("this.scenarioToEdit.intervalEnd" + this.scenarioToEdit.intervalEnd)

      let startDate = DateUtils.stringUTCDateToLocalDateObject(this.scenarioToEdit.intervalStart)
      let endDate = DateUtils.stringUTCDateToLocalDateObject(this.scenarioToEdit.intervalEnd)

      console.log(startDate);
      console.log(endDate);

      this.fromDate = { year: startDate.getFullYear(), month: startDate.getMonth() + 1, day: startDate.getDate() };
      this.toDate = { year: endDate.getFullYear(), month: endDate.getMonth() + 1, day: endDate.getDate() };

      if (this.fromDate && this.toDate) {

        let fromDate: any;
        let toDate: any;

        fromDate = this.dateUtils.dateStringToString1(this.fromDate.year, this.fromDate.month, this.fromDate.day);
        toDate = this.dateUtils.dateStringToString1(this.toDate.year, this.toDate.month, this.toDate.day);

        if (this.fromDate.year && this.fromDate.month && this.fromDate.day && this.toDate && this.toDate.month && this.toDate.day) {
          this.switchingStateInTimePeriodList = [];

          // if(localStorage.getItem('scenariosFromGPlan')){

          //   // this.switchingStateInTimePeriodList = JSON.parse(localStorage.getItem('scenariosFromGPlan'));
          //   // console.log("Here is the assigned one: ", this.switchingStateInTimePeriodList);
          //   console.log("FRom date ", this.fromDate, " to Date " , this.toDate);
          //   JSON.parse(localStorage.getItem('scenariosFromGPlan')).forEach((scenario) => {
          //     if(this.planning_name == scenario.name){
          //       // console.log("ARE WE FUCKING DUMB? |");
          //       this.switchingStateInTimePeriodList = scenario.planningSwitchingStates;
          //       console.log("here is updated switching statein time period list: ", scenario.planningSwitchingState)
          //     }
          //     console.log("Here is the interval start: ", DateUtils.stringUTCDateToLocalDateObject(scenario.intervalStart), " and interval end : ", DateUtils.stringUTCDateToLocalDateObject(scenario.intervalEnd));
          //   })
          // }
          // let availableScenariosPlanning;
          this.gplanService.getListAvailableScenarios().subscribe((scenarios: Array<GPlanInput>) => {
            this.availableScenariosPlanning = scenarios
            console.log("here are the list of available scenarios :", this.availableScenariosPlanning);
          });
          // JSON.parse(localStorage.getItem('scenariosFromGPlan') || '[]').forEach((scenario) => {
          //   this.availableScenariosPlanning.push(scenario);
          // });
          // console.log("Here is available scenarios planning from local storage: ", this.availableScenariosPlanning);
          // console.log("Here is the list of cable switching states: ", this.switchingStateInTimePeriodList);

          // this.availableScenariosPlanning.forEach((scenario) => {
          //   if(scenario.name == this.)
          // })
          // console.log("here is the list of avaliable scenarios : ", availableScenariosPlanning);
          this.mapService.getSwitchingStateInTimePeriod(this.topology.topologyId, fromDate, toDate).subscribe(
            (cableSwitchingStateList: Array<SwitchingStateInTimePeriod>) => {
              if (cableSwitchingStateList) {
                this.switchingStateInTimePeriodList = cableSwitchingStateList;
                //load original switching state for edit mode
                this.switchingStateInTimePeriodList.forEach(original => {
                  this.availableScenariosPlanning.forEach((scenario: GPlanInput) => {
                    if(this.planning_name == scenario.name && scenario.planningSwichtingStates){
                      scenario.planningSwichtingStates.forEach((switchingState: PlanningSwitchingState) => {
                        if(switchingState.cableGridelementId == original.cableGridElementID){
                          console.log("Here is the switching state from storage : ", switchingState);
                          console.log("here is the original values from swithching state: ", original);
                          original.original = original.switchingState;
                          original.switchingState = switchingState.switchingState;
                        }
                      })
                    }
                    if(!scenario.planningSwichtingStates){
                      original.original = original.switchingState;
                    }
                  })
                });


                //load switching state to edit

              }
            }
          );
        }

        if (this.fromDate.year && this.fromDate.month && this.fromDate.day
          && this.toDate && this.toDate.month && this.toDate.day) {
          this.switchingStateToNeighbourList = [];
          this.mapService.getSwitchingStateToNeighbourInTimePeriod(this.topology.topologyId, fromDate, toDate).subscribe(
            (switchingStateToNeighbour: Array<SwitchingStateInTimePeriod>) => {
              if (switchingStateToNeighbour) {
                this.switchingStateToNeighbourList = switchingStateToNeighbour;
                //load original switching state for edit mode
                this.switchingStateToNeighbourList.forEach(original => {
                  original.original = original.switchingState
                });


                //load switching state to Neighbour to edit
                if (this.switchingStateToNeighbourList) {
                  this.switchingStateToNeighbourList.forEach(switchingState => {
                    if (this.scenarioToEdit.planningSubgridsDtos) {
                      this.scenarioToEdit.planningSubgridsDtos.forEach(edited => {
                        if (switchingState.cableGridElementID == edited.cableGridelementId) {
                          switchingState.switchingState = edited.switchingState
                          let stateId = this.getPlanningStateByName(switchingState.switchingState)
                          this.onSelectSubTree(stateId, switchingState);
                        }
                      });
                    }

                  });
                }
              }
            }
          );
        }
      }
    }
    console.log(this.fromDate);
    console.log(this.toDate);
  }


  // get the Source Node of a cable by gridElementId
  private getCableSourceNode(id: number) {
    let cableSourceNode: string = "";
    let cablesJson: string = localStorage.getItem('cables');
    let cables: Array<Cable> = JSON.parse(cablesJson);
    if (cables) {
      cables.forEach(element => {
        if (element.gridElementId == id) {
          cableSourceNode = this.getNodeName(element.startNodeId);
        }
      });
    }
    return cableSourceNode;
  }

  // get the ENd Node of a cable by gridElementId
  private getCableEndNode(id: number) {
    let cableEndNode: string = "";
    let cablesJson: string = localStorage.getItem('cables');
    let cables: Array<Cable> = JSON.parse(cablesJson);
    if (cables) {
      cables.forEach(element => {
        if (element.gridElementId == id) {
          cableEndNode = this.getNodeName(element.endNodeId);
        }
      });
    }
    return cableEndNode;
  }


  getPlanningStateByName(stateName: string) {
    let planninStateId: number;
    if (this.planningList) {
      this.planningList.forEach(element => {
        if (element.state == stateName || element.state_en == stateName) {
          planninStateId = element.id;
        }
      });
    }
    return planninStateId;
  }

  /**
 * Check selected date range
 * The method return true when the "fromDate" is previous of "toDate",
 * and return false in all other cases
 * @returns Boolean (true/false)
 */
  checkSelectedRangeDate() {
    if (this.fromDate && this.toDate) {
      let fDate = new NgbDate(this.fromDate.year, this.fromDate.month, this.fromDate.day)
      let tDate = new NgbDate(this.toDate.year, this.toDate.month, this.toDate.day)
      if (tDate.after(fDate) || fDate.equals(tDate)) {
        return false
      }
      else {
        return true
      }
    }
    else {
      return true
    }
  }

  openGPlanDialogMapView() {
    this.ngbModal.open(
      MapViewDialogComponent,
      {
        size: 'xl',
        centered: true,
        scrollable: false,
        backdrop: 'static'
      }).result.then((result) => {
        console.log(result);
      }, (reason) => {
        console.log(reason.target.options.title);
        if (reason && reason.target && reason.target.options && reason.target.options.title) {
          // console.log("Reason target options ...", reason.target.options)
          if(this.additionalLoadGenerationOn){
            this.formAdditionalLoadGeneration.patchValue({
              node: reason.target.options.title
            });
          }
          if(this.nodeAdditionalLoadGenerationOn){
            this.formNewNodeTab.patchValue({
              nodeNodeTab: reason.target.options.title
            })
          }
        }
      });
  }

  onToggle(e: any) {
    this.toggleValue = !this.toggleValue;
    this.defaultDeratingFactorValue = 1;
    console.log(e.target.checked);
    this.worstCaseEnabled = e.target.checked;
    if (this.worstCaseEnabled == true) {
      this.getSwitchingStateToNeighbourLastTopologyChange();
      if (this.scenarioToEdit && this.scenarioToEdit.type == 'WC') {
        //if value is negative -> cos fi capacitive
        if (this.scenarioToEdit.powerFactorExistingGenerator < 0) {
          this.formWorstCase.patchValue({
            voltageAtRoot: this.scenarioToEdit.voltageAtRoot,
            powerFactorExistingGenerator: Math.abs(this.scenarioToEdit.powerFactorExistingGenerator),
            powerFactor: "capacitive",
            deratingFactor: this.scenarioToEdit.deratingFactorExistingGenerator
          });
        }
        //if value is 0 or positive -> cos fi inductive
        else {
          this.formWorstCase.patchValue({
            voltageAtRoot: this.scenarioToEdit.voltageAtRoot,
            powerFactorExistingGenerator: Math.abs(this.scenarioToEdit.powerFactorExistingGenerator),
            powerFactor: "inductive",
            deratingFactor: this.scenarioToEdit.deratingFactorExistingGenerator
          });
        }
      }
      else {
        const root: GridElementRoot = JSON.parse(localStorage.getItem("root"));
        if (root && root.voltageAtRoot) {
          this.formWorstCase.patchValue({
            voltageAtRoot: root.voltageAtRoot,
            powerFactorExistingGenerator: 0.9,
            powerFactor: "inductive",
            deratingFactor: this.defaultDeratingFactorValue

          });
        }
      }
    }
    if(this.editPlanningScenarioMode)
      this.fillPlanningTab();
  }

  onToggleRefPV(event: any){
    this.toggleRefPV = !this.toggleRefPV;
    if(this.toggleRefPV){
      this.toggleRefPVValue = "refPV";
    }else{
      this.toggleRefPVValue = "";
    }
  }

  showModifyLineTab(){
    this.modifyLineTabEnabled = !this.modifyLineTabEnabled;
  }

  showSwitchWithinTheCurrentTopologyTab(){
    this.switchWithinCurrentTopologyTabEnabled = !this.switchWithinCurrentTopologyTabEnabled;
  }

  showSwitchToAdjacentTopologiesTab(){
    this.switchToAdjacentTopologyTabEnabled = !this.switchToAdjacentTopologyTabEnabled;
  }

  ngOnDestroy() {
    this.planning_name = null;
  }
}
